<template>
    <base-layout>
        <h1 slot="header">
            {{ `app.pages.settings.appearance` | trans}}
        </h1>
        <a slot="buttons" :href="routes.settings" class="btn btn-primary">
            <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
            {{ `app.back`|trans }}
        </a>
        <v-app id="vuetify-app">
            <v-container fluid >
                <h4>{{`app.settings.background`|trans}}</h4>
                <v-alert :value="true" :type="`info`" class="mt-4">
                    {{`app.settings.change_background` | trans}}
                </v-alert>
              <v-layout justify-end>
                <loading-button class="mt-4 mb-4" :loaging="appearanceIsLoading" :status="appearanceStatus"
                                @click="updateAppearance()">
                  <i class="fa fa-save"></i> {{`app.save`|trans}}
                </loading-button>
              </v-layout>
              <v-layout justify-center>
                <image-picker
                    ref="imagePicker"
                    :dataImages="images"
                    :h="'200px'"
                    :w="'200px'"
                    :useLabel="true"
                    @onselectimage="onSelectImage($event)"
                >
                </image-picker>
              </v-layout>
                <v-alert :value="true" :type="`info`" class="mt-4 mb-4">
                    {{`app.settings.custom_color` | trans}}
                </v-alert>
                <v-layout align-center column>
                    <color-picker v-model="color" @input="colorChange()"></color-picker>
                </v-layout>
              <loading-button class="mt-5 pull-right" :loaging="appearanceIsLoading" :status="appearanceStatus"
                              @click="updateAppearance()">
                <i class="fa fa-save"></i> {{`app.save`|trans}}
              </loading-button>
            </v-container>
        </v-app>
    </base-layout>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {Chrome} from 'vue-color'
    import {trans} from "../../app";
    import VueSelectImage from 'vue-select-image'

    require('vue-select-image/dist/vue-select-image.css')

    export default {
        props: {
            routes: Object
        },
        components: {
            'color-picker': Chrome,
            'image-picker': VueSelectImage,
        },
        data: () => ({
            appearanceIsLoading: false,
            appearanceStatus: '',
            appearance: {
                background_image: null,
                background_color: null,
            },
            color: {
                hex: '#FFFFFF'
            },
            images: [
                {
                    id: 'default.jpg',
                    src: `${window.location.origin}/img/dashboard/small/default.jpg`,
                    alt: trans('app.default')
                },
                {
                    id: 'fig.jpg',
                    src: `${window.location.origin}/img/dashboard/small/fig.jpg`,
                    alt: trans('app.settings.fig')
                },
                {
                    id: 'food.jpg',
                    src: `${window.location.origin}/img/dashboard/small/food.jpg`,
                    alt: trans('app.settings.food')
                },
                {
                    id: 'fruits.jpg',
                    src: `${window.location.origin}/img/dashboard/small/fruits.jpg`,
                    alt: trans('app.settings.fruits')
                },
                {
                    id: 'macarons.jpg',
                    src: `${window.location.origin}/img/dashboard/small/macarons.jpg`,
                    alt: trans('app.settings.macarons')
                },
                {
                    id: 'pineapple.jpg',
                    src: `${window.location.origin}/img/dashboard/small/pineapple.jpg`,
                    alt: trans('app.settings.pineapple')
                },
                {
                    id: 'plums.jpg',
                    src: `${window.location.origin}/img/dashboard/small/plums.jpg`,
                    alt: trans('app.settings.plums')
                },
                {
                    id: 'yoghurt.jpg',
                    src: `${window.location.origin}/img/dashboard/small/yoghurt.jpg`,
                    alt: trans('app.settings.yoghurt')
                },
                {
                    id: 'pasta.jpg',
                    src: `${window.location.origin}/img/dashboard/small/pasta.jpg`,
                    alt: trans('app.settings.pasta')
                },
                {
                    id: 'kitchen.jpg',
                    src: `${window.location.origin}/img/dashboard/small/kitchen.jpg`,
                    alt: trans('app.settings.kitchen')
                },
                {
                    id: 'eyeglasses.jpg',
                    src: `${window.location.origin}/img/dashboard/small/eyeglasses.jpg`,
                    alt: trans('app.settings.eyeglasses')
                },
                {
                    id: 'macbook_pro.jpg',
                    src: `${window.location.origin}/img/dashboard/small/macbook_pro.jpg`,
                    alt: trans('app.settings.macbook_pro')
                },
                {
                    id: 'dark.png',
                    src: `${window.location.origin}/img/dashboard/dark.png`,
                    alt: trans('app.settings.colors.dark')
                },
                {
                    id: 'green.png',
                    src: `${window.location.origin}/img/dashboard/green.png`,
                    alt: trans('app.settings.colors.green')
                },
                {
                    id: 'grey.png',
                    src: `${window.location.origin}/img/dashboard/grey.png`,
                    alt: trans('app.settings.colors.grey')
                },
            ],
        }),
        methods: {
            ...mapActions(['fetchSettings']),
            async updateAppearance() {
                this.appearanceIsLoading = true;

                try {
                    await axios.put('/settings/appearance', this.appearance);
                    this.appearanceStatus = true;
                    this.$toast.success(trans('app.actions.saved', {name: trans('app.pages.settings.index').toLowerCase()}));
                } catch (error) {
                    this.appearanceStatus = false;
                    if (error.response && error.response.status === 422) {
                        this.$toast.error(trans('app.save_failed'));
                    } else {
                        this.sentryCaptureException(error);
                    }
                }

                this.appearanceIsLoading = false;
            },
            onSelectImage(image) {
                this.appearance.background_image = image.id;
                this.appearance.background_color = null;
            },
            colorChange() {
                this.$refs.imagePicker.removeFromSingleSelected();
                this.appearance.background_image = null;
                this.appearance.background_color = this.color.hex;
            },
        },
        created() {
            this.fetchSettings()
                .then(() => {
                    this.appearance = this.$store.state.settings.appearance;
                    if (this.appearance.background_color !== null) {
                        this.color = {
                            hex: this.appearance.background_color,
                            source: 'hex'
                        }
                    }

                    this.$refs.imagePicker.selectedImages = [this.images.find(image => {
                        return image.id === this.appearance.background_image;
                    })];
                    this.$refs.imagePicker.setInitialSelection();
                }).catch((error) => {
                  this.sentryCaptureException(error);
                });
        }
    }
</script>
<style scoped>
    .vue-select-image__lbl {
        text-align: center;
        width: 100%;
    }

    .vue-select-image__item{
      margin:0 15px 15px;
    }
</style>
